import React from 'react';
import { useResourceIdInputQuery } from '../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../dum';
import { IAccount, IS_SUPPLIER } from '../account-form';
import { useWatch } from 'react-hook-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function ResourceIdInput() {
    const inputName: keyof IAccount = 'resource_id';
    const { data } = useResourceIdInputQuery();

    const isSupplier = useWatch({
        name: IS_SUPPLIER,
    }) as IAccount['is_supplier'];

    const options = data?.getResources || [];

    if (!isSupplier) return null;

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(FIELD_LABELS.resource_id)}
            options={options}
        />
    );
}
